export var UspV1Field;
(function (UspV1Field) {
    UspV1Field["VERSION"] = "Version";
    UspV1Field["NOTICE"] = "Notice";
    UspV1Field["OPT_OUT_SALE"] = "OptOutSale";
    UspV1Field["LSPA_COVERED"] = "LspaCovered";
})(UspV1Field || (UspV1Field = {}));
export const USPV1_CORE_SEGMENT_FIELD_NAMES = [
    UspV1Field.VERSION,
    UspV1Field.NOTICE,
    UspV1Field.OPT_OUT_SALE,
    UspV1Field.LSPA_COVERED,
];
